.content {
  background-color: #2d2f33;
  border-radius: var(--border-radius-large);
  width: 100%;
  max-width: 32rem;
  min-width: 24rem;
  padding: 0.4rem 0.4rem 0.4rem;
  z-index: 1000;
  min-height: 4.4rem;
  max-height: 50rem;
  overflow-y: auto;

  &[data-production='true'] {
    padding-bottom: 4.8rem;
  }

  @media screen and (min-width: 1784px) {
    min-width: 32rem;
  }
}

.item {
  padding: 0.6rem;
  font-size: 1.4rem;
  color: var(--text-color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--border-radius-medium);
  background-color: transparent;
  overflow: hidden;

  &:not(:last-child) {
    margin-bottom: 0.4rem;
  }

  &[data-active='true'] {
    background-color: #28292d;
  }

  &[data-active='true'] {
    background-color: #28292d;
  }

  &[data-highlighted] {
    cursor: pointer;
    background-color: #28292d;
  }
}

.dropdown-element-left {
  display: flex;
  align-items: center;
}

.check-item {
  width: 2.4rem;
  height: 1.8rem;
  margin-right: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 1.2rem;
    height: 1.2rem;
    fill: var(--step-title-color);
  }
}

.name {
  font-size: 1.4rem;
  font-weight: 500;
  color: #ffffff99;
}

.date-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #8a8f98;
  white-space: nowrap;
}

.step-status-wrapper {
  width: 2.4rem;
  height: 1.8rem;
  margin-right: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
